export default {
    modalShowImageVariations: {
        imageAi: 'Image AI',
        regenerateImage: 'Generar nuevo contenido',
        description: 'Descripción:',
        style: 'Style:',
        saveToLibrary: 'Save to Library',
        continue: 'Continuar',
        cancel: 'Cancelar',
        select: 'Select',
        copy: 'Redacción',
    },
};
